// Iter 648 — Antrean Haikal (Mesin Press) segera diperbarui: poll sidik ringan ~12 dtk,
//   muat ulang daftar penuh HANYA saat sidik berubah. Filter/kartu terbuka tidak di-reset.
import React, { useCallback, useEffect, useRef, useState } from "react";
import axios from "axios";
import { useAutoRefresh, isDirty, subscribeDirty } from "./use_auto_refresh";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const PRESS_CHANGED_EVENT = "press-queue-changed";

export function PressLiveBar({ onOfflineChanged }) {
  const sig = useRef(null);
  const pendingOffline = useRef(false);
  const [at, setAt] = useState(null);
  const [err, setErr] = useState("");

  const applyOffline = useCallback(() => {
    if (isDirty()) { pendingOffline.current = true; return; }
    pendingOffline.current = false;
    return Promise.resolve(onOfflineChanged?.()).catch(() => {});
  }, [onOfflineChanged]);

  useEffect(() => subscribeDirty((n) => { if (!n && pendingOffline.current) applyOffline(); }), [applyOffline]);

  const check = useCallback(async () => {
    try {
      const r = await axios.get(`${API}/press/queue-signature`, { withCredentials: true, timeout: 10000 });
      const prev = sig.current;
      sig.current = r.data;
      if (prev) {
        if (prev.offline !== r.data.offline) applyOffline();
        if (prev.shopee !== r.data.shopee) window.dispatchEvent(new Event(PRESS_CHANGED_EVENT));
      }
      setAt(new Date()); setErr("");
    } catch (e) { setErr("Gagal memeriksa pembaruan"); }
  }, [applyOffline]);

  useEffect(() => { check(); }, [check]);
  useAutoRefresh({ enabled: true, intervalMs: 12_000, onRefresh: check, pauseWhenDirty: false });

  return <div className="press-live" data-testid="press-live-bar">
    <span className="press-live-dot" aria-hidden="true"/>
    <span data-testid="press-live-updated">{err || (at ? `Otomatis · diperbarui ${at.toLocaleTimeString("id-ID", { hour: "2-digit", minute: "2-digit", second: "2-digit" })}` : "Memeriksa…")}</span>
  </div>;
}
